exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wrapper{padding:16px 15px;color:#241f1f;line-height:25px}h3{font-size:15px;text-align:center;margin-bottom:18px}h3,h4{font-weight:700}h4{font-size:13px;margin-top:18px;margin-bottom:10px}.thick{font-weight:700}.btm{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:50px;width:100%;position:fixed;bottom:0;background-color:#fff;box-shadow:0 -2px 4px 0 hsla(0,0%,86%,.5)}.btm button{width:1920px;height:37px;line-height:37px;background-color:#00b8e0;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a1c522aa","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/privacy/privacy.vue
// module id = 185
// module chunks = 1